import { render, staticRenderFns } from "./MuteButton.vue?vue&type=template&id=4c7ca60c&"
import script from "./MuteButton.vue?vue&type=script&lang=js&"
export * from "./MuteButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports